import {useLocation} from 'react-router-dom';
import useGetSubProducts from './hooks/useGetSubProducts';
import Header from 'modules/header/farm/main';
import useSetSubProduct from './hooks/usePatchSubProduct';
import Item from './item';

const SubProductPage = () => {
  const location = useLocation();
  const {subProducts, isLoading} = useGetSubProducts(location?.state?.product);
  const {mutate} = useSetSubProduct(location?.state?.product);
  return (
    <>
      <Header title="انتخاب زیر‌دسته محصول" />
      <div className=" mt-12 px-3">
        {!isLoading && (
          <>
            {subProducts &&
              subProducts?.map(item => (
                <Item
                  key={item.guid}
                  guid={item.guid}
                  title={item.title}
                  locationGuid={location?.state?.guid}
                  mutate={mutate}
                />
              ))}
          </>
        )}
      </div>
    </>
  );
};

export default SubProductPage;
